module.exports = __webpack_public_path__ + "static/media/IconTemplates_-27.1b22eba1.svg";